import { StackList } from './stackList';

export class QueueList<T> {
  private list: T[];

  private history = new StackList<T>([]);

  constructor(elements: T[] = []) {
    this.list = elements;
  }

  get top(): T {
    return this.list[0];
  }

  get length(): number {
    return this.list.length;
  }

  get total(): number {
    return this.list.length + this.history.length;
  }

  append(element: T): void {
    this.list.push(element);
  }

  forward(): void {
    const element = this.list.shift();
    if (element) {
      this.history.append(element);
    }
  }

  backward(): void {
    const element = this.history.forward();
    if (element) {
      this.list.unshift(element);
    }
  }

  empty(): void {
    this.list.forEach((element) => this.history.append(element));
    this.list = [];
  }

  isEmpty(): boolean {
    return this.list.length === 0;
  }

  filter(condition: (item) => boolean): T[] {
    return this.list.filter(condition);
  }
}
